export default __webpack_public_path__ + "static/media/hero-184dcfc71518fbbf5f5fb998be20a0c1.png";